import DefaultRemoteGuide from './remote';
import { RemoteGuide } from './types';
import { isPrivateVersion } from 'common-module/src/util';

const TIMEOUT = 30000;
const instance = new DefaultRemoteGuide();
let isInstalled = false;
let resolveInstall: (value: RemoteGuide) => void;
let rejectInstall: (reason?: any) => void;
let installPromise: Promise<RemoteGuide> = new Promise((resolve, reject) => {
  resolveInstall = resolve;
  rejectInstall = reject;
});

const ASYNC_FUNCTIONS = ['identify', 'setUserProperties', 'group', 'setGroupProperties', 'show'];

export default new Proxy<RemoteGuide>({} as RemoteGuide, {
  get: (target, prop, receiver) => {
    if (isPrivateVersion) {
      if (prop === 'install' || ASYNC_FUNCTIONS.includes(prop as string)) {
        return async () => {};
      }
      return () => {};
    }
    if (prop === 'install') {
      return async () => {
        if (isInstalled) {
          window.console.warn('RemoteGuide already installed');
          return;
        }
        const timer = setTimeout(() => {
          rejectInstall(new Error('RemoteGuide install timeout'));
          isInstalled = false;
          installPromise = new Promise((resolve, reject) => {
            resolveInstall = resolve;
            rejectInstall = reject;
          });
        }, TIMEOUT);
        isInstalled = true;
        instance.install().then(() => {
          resolveInstall(instance);
          console.log('RemoteGuide install success');
        }).catch(rejectInstall).finally(() => {
          clearTimeout(timer);
        });
        return;
      };
    }
    if (Reflect.has(instance, prop)) {
      const key = prop as keyof RemoteGuide;
      const fn = instance[key];
      if (typeof fn === 'function' && ASYNC_FUNCTIONS.includes(key)) {
        return async (...args: any[]) => {
          if (!isInstalled) {
            await receiver.install();
          }
          await installPromise;
          return Reflect.apply(fn, instance, args);
        };
      }
      return fn;
    }
    return undefined;
  }
});

